import { useCallback } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';

export const useSetStatus = () => {
  const { dispatch } = useCampaignEditorContext();
  return useCallback(
    (status: 'Draft' | 'Test' | 'Live') => dispatch({ type: 'SET_CAMPAIGN_STATUS', payload: { status } }),
    [dispatch],
  );
};
